import React, { useState } from 'react';
import SendCodeButton from '../personal-info/SendCodeButton';

const CheckCircleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-3 w-3"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

const ErrorIcon = () => (
  <svg
    className="h-3.5 w-3.5 flex-shrink-0"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

const FormField = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  icon,
  verified,
  dir = 'rtl',
  required = false,
  error,
  type = 'text',
  showVerificationButton,
  showVerificationInput,
  onSendCode,
}) => {
  const [focused, setFocused] = useState(false);
  const hasLeftSlot = verified || (showVerificationButton && !showVerificationInput);

  return (
    <div className="w-full">

      {/* Label */}
      <label
        htmlFor={name}
        className={`mb-1.5 block text-sm font-medium transition-colors duration-150 ${
          focused ? 'text-indigo-600' : 'text-gray-700'
        }`}
      >
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>

      {/* Input wrapper */}
      <div className="relative">

        {/* Right icon */}
        {icon && (
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400">
            {icon}
          </div>
        )}

        <input
          type={type}
          id={name}
          name={name}
          value={value || ''}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={(e) => {
            setFocused(false);
            onBlur?.(e);
          }}
          placeholder={placeholder}
          dir={dir}
          className={`w-full rounded-xl border bg-white py-2.5 text-base outline-none transition-all duration-150 sm:py-3 sm:text-sm
            ${icon ? 'pr-10' : 'pr-4'}
            ${hasLeftSlot ? 'pl-28' : 'pl-4'}
            ${
              error
                ? 'border-red-400 bg-red-50 focus:ring-2 focus:ring-red-200'
                : focused
                ? 'border-indigo-400 shadow-sm shadow-indigo-100 focus:ring-2 focus:ring-indigo-100'
                : 'border-gray-200 hover:border-gray-300'
            }`}
        />

        {/* Left slot — verified badge or send code button */}
        {hasLeftSlot && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-3">
            {verified ? (
              <span className="inline-flex items-center gap-1 rounded-full border border-emerald-100 bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700">
                מאומת
                <CheckCircleIcon />
              </span>
            ) : (
              <SendCodeButton onSendCode={onSendCode} name={name} />
            )}
          </div>
        )}

      </div>

      {/* Error message */}
      {error && (
        <p className="mt-1.5 flex items-center gap-1 text-xs text-red-500">
          <ErrorIcon />
          {error}
        </p>
      )}

    </div>
  );
};

export default FormField;